import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { Router, NavigationEnd } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class NavegationService {

  private readonly localStorageKey = 'rutas';
  private history: string[];

  constructor(private router: Router, private location: Location) {
    this.history = JSON.parse(localStorage.getItem(this.localStorageKey)) || [];
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.history.push(event.urlAfterRedirects);
        localStorage.setItem(this.localStorageKey, JSON.stringify(this.history));
      }
    });
  }

  back(): void {
    this.history.pop();
    localStorage.setItem(this.localStorageKey, JSON.stringify(this.history));
    if (this.history.length > 0) {
      this.location.back();
    } else {
      const pageHome = localStorage.getItem('home');
      this.router.navigateByUrl(pageHome);
    }
  }
}